import axios from '@/service';
import DynamicService from '@/service/DynamicService';
import MdfeSchema from '../schemas/MdfeSchema';
import {
  formatDatePT,
  getText,
} from '@/utils';
import { typePage, ENVIRONMENT_INVOICE } from '@/utils/enums';
import { mdfesStatus } from '@/utils/options';
import { clone } from 'lodash';

const formatResponse = (item, type = typePage.LIST) => {
  const formatList = (item) => {
    item.created_at_formatted = formatDatePT(item.created_at);
    item.status_formatted = getText(mdfesStatus, item.status);
    item.identification.environment_formatted = item.identification.environment === ENVIRONMENT_INVOICE.homologation ? 'Homologação' : 'Produção';
  };

  const formatShow = (product_invoice) => {
    
  };

  type === typePage.LIST ? formatList(item) : formatShow(item.product_invoice);
};

const formatRequest = (data) => {
  const payload = clone(data);

  return payload;
};

const formatResponseGetListSelects = (data) => {
  return data;
};

const MdfeService = DynamicService(MdfeSchema.domain,
  MdfeSchema, { formatResponse, formatRequest, removeNullable: false });

const MdfeCommands = () => ({
  async transmit(payload) {
    return await axios.post(`/${MdfeSchema.domain}/transmit`, payload);
  },
});

export default MdfeService;
export { MdfeService, MdfeCommands };
